import React from 'react'
import classNames from 'classnames'
import tenantConfig from 'config/tenant'
import './Loader.scss'

interface LoaderProps {
  /** Caption shown under the loader. Pass `null` to hide it entirely. */
  message?: string | null;
  /** `splash` covers the full viewport in dark; `inline` fills its parent. Default: `splash`. */
  variant?: 'splash' | 'inline';
}

/**
 * Branded loading indicator. Tenant logo in the centre, twin counter-rotating arcs around it.
 * Visual reference: the splash spinner the user shared. Background defaults to near-black so the
 * orange logo pops; switch `variant="inline"` for a transparent in-context spinner.
 */
const Loader: React.FC<LoaderProps> = ({ message, variant = 'splash' }) => (
  <div
    className={classNames('loader-backdrop', `loader-backdrop--${variant}`)}
    data-testid="loader"
  >
    <div className="loader">
      <span className="loader__ring loader__ring--outer" aria-hidden />
      <span className="loader__ring loader__ring--inner" aria-hidden />
      <img
        src={tenantConfig.logoIcon}
        alt={tenantConfig.name}
        className="loader__icon"
      />
    </div>
    {message !== null && (
      <p className="loader__message">{message ?? 'Loading…'}</p>
    )}
  </div>
)

export default Loader
